import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';

interface StatusMessageProps {
  disabled: boolean;
}

export const StatusMessage = ({ disabled = false }: StatusMessageProps) => {
  return (
    <div>
      <Typography
        variant="h5"
        weight="bold"
        color={disabled ? 'inactive' : 'primary'}
      >
        You haven&apos;t saved an address.
      </Typography>

      <Typography color={disabled ? 'inactive' : 'primary'}>
        Add an address for quick and easy checkout the next time you shop.
      </Typography>
    </div>
  );
};
